import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import * as React from 'react';
import { customPalette } from '../../themes/customTheme';

export default function DatePickerValue({ label, value, onChange }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        sx={{
          width: '165px',
          '& > div': {
            backgroundColor: customPalette.background.main,
            '&:hover': {
              backgroundColor: customPalette.greyStoke,
            },
          },
        }}
        //
        label={label ?? 'Fecha'}
        value={dayjs(value, 'YYYY-MM-DD')}
        onChange={newValue => onChange(newValue)}
        disableHighlightToday
      />
    </LocalizationProvider>
  );
}
